/**
 * Safe Toast - Wrapper für Mobile-kompatible Toast-Aufrufe
 * 
 * Verwendet doppelten requestAnimationFrame um sicherzustellen,
 * dass das DOM stabil ist bevor ein Toast angezeigt wird.
 * 
 * Dies verhindert den insertBefore Fehler auf Mobile Chrome.
 */
import { toast as sonnerToast } from 'sonner';

/**
 * Führt eine Funktion nach zwei Animation Frames aus
 * Dies gibt dem Browser Zeit, das DOM zu stabilisieren
 */
const scheduleAfterPaint = (callback) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      callback();
    });
  });
};

/**
 * Sichere Toast-Funktionen mit RAF-Delay
 */
const toast = {
  success: (message, options) => {
    scheduleAfterPaint(() => {
      try {
        sonnerToast.success(message, options);
      } catch (e) {
        console.log('[Toast success]:', message);
      }
    });
  },
  
  error: (message, options) => {
    scheduleAfterPaint(() => {
      try {
        sonnerToast.error(message, options);
      } catch (e) {
        console.error('[Toast error]:', message);
      }
    });
  },
  
  info: (message, options) => {
    scheduleAfterPaint(() => {
      try {
        sonnerToast.info(message, options);
      } catch (e) {
        console.log('[Toast info]:', message);
      }
    });
  },
  
  warning: (message, options) => {
    scheduleAfterPaint(() => {
      try {
        sonnerToast.warning(message, options);
      } catch (e) {
        console.warn('[Toast warning]:', message);
      }
    });
  },
  
  // Für direkten Aufruf
  message: (message, options) => {
    scheduleAfterPaint(() => {
      try {
        sonnerToast(message, options);
      } catch (e) {
        console.log('[Toast]:', message);
      }
    });
  },
  
  // Promise-basierte Toasts
  promise: (promise, options) => {
    return sonnerToast.promise(promise, options);
  },
  
  // Dismiss
  dismiss: (id) => {
    sonnerToast.dismiss(id);
  }
};

export { toast };
export default toast;
